import { SimpleMenu } from '@/ui/components/SimpleMenu'
import { AccountModule } from '@core/modules/account/account.module'
import { MenuItem } from '../SimpleMenu/SimpleMenu'
import HeaderTitle from '@/ui/layouts/dashboard/components/header/headerTitle/HeaderTitle'
import { useState } from 'react'
import Typography from '@/ui/components/typography'
import { useCustomTheme } from '@/core/theme'

const AccountPicker = () => {
    const theme = useCustomTheme()
    const { currentAccount, accounts, expiredAccountsNames } = AccountModule.useStore()
    const [open, setOpen] = useState(false)

    const activeItems: MenuItem[] = Object.values(accounts).map((account) => ({
        id: account.id!,
        value: account.company_name!,
        action: () => account.id === currentAccount?.id ? null : handleAccountSelect(account.id!),
        selected: account.id === currentAccount?.id,
    }))

    if (expiredAccountsNames.length > 0) {
        activeItems[activeItems.length - 1].addDivider = true
    }

    const expiredItems: MenuItem[] =
        expiredAccountsNames.length > 0
            ? expiredAccountsNames.map((accountName) => ({
                  id: `expired-${accountName}`,
                  value: accountName,
                  disabled: true,
                  rightElement: (
                      <Typography
                          variant="xs-regular"
                          color={theme.colors.semantic.error}
                      >
                          Expired
                      </Typography>
                  ),
              }))
            : []

    const items: MenuItem[] = [...activeItems, ...expiredItems]
    const isActivatorEnabled = items.length > 1

    const handleAccountSelect = async (accountId: string) => {
        setOpen(false)
        await AccountModule.switchAccount(accountId)
    }

    return (
        <div data-testid="account-picker">
            <SimpleMenu
                open={open}
                onActivate={() => setOpen(!open)}
                onClose={() => setOpen(false)}
                activator={<HeaderTitle />}
                items={items}
                isActivatorEnabled={isActivatorEnabled}
                duration={0}
                menuPosition="fixed"
            />
        </div>
    )
}

export default AccountPicker
